import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import UserFavoritesServicesFactory from '../../userFavorites/Services/factory.js'
import UserFavoritesRepositoriesFactory from '../Repositories/factory.js'
import {UserFavoriteRequestsFactory} from '../Request/factory.js'
import AddUserFavoriteUseCase from './AddUserFavoriteUseCase.js'
import DeleteUserFavoriteUseCase from './DeleteUserFavoriteUseCase.js'
import GetUserFavoritesUseCase from './GetUserFavoritesUseCase.js'
import UnsubscribeUserFavoriteUseCase from './UnsubscribeUserFavoriteUseCase.js'

export default class UserFavoritesUseCasesFactory {
  static getUserFavoritesUseCase = ({config}) =>
    new GetUserFavoritesUseCase({
      getUserFavoritesService: UserFavoritesServicesFactory.getUserFavoritesService({config})
    })

  static deleteUserFavoriteUseCase = ({config}) =>
    new DeleteUserFavoriteUseCase({
      repository: UserFavoritesRepositoriesFactory.hTTPUserFavoritesRepository({
        config
      }),
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })

  static addUserFavoriteUseCase = ({config}) =>
    new AddUserFavoriteUseCase({
      repository: UserFavoritesRepositoriesFactory.hTTPUserFavoritesRepository({
        config
      }),
      userNotLoggedInError: UserErrorsFactory.userNotLoggedInUserError,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      })
    })

  static unsubscribeUserFavoriteUseCase = ({config}) =>
    new UnsubscribeUserFavoriteUseCase({
      repository: UserFavoritesRepositoriesFactory.hTTPUserFavoritesRepository({
        config
      }),
      unsubscribeUserFavoriteRequestFactory: UserFavoriteRequestsFactory.unsubscribeUserFavoriteRequestFactory
    })
}
